import { Prisma } from "@prisma/client";

export const defaultSocietyValues = {
	id: undefined,
	siren: "",
	denomination: "",
	streetNumber: "",
	streetName: "",
	postalCode: "",
	city: "",
};

export const defaultClientSocietyValues = {
	...defaultSocietyValues,
	isSyndic: false,
	hasUserAccess: "false",
	hasBrokerageFees: "false",
	userAccess: {
		lastname: "",
		firstname: "",
		email: "",
	},
};


export const brokerSocietyBaseSelector = {
	id: true,
	denomination: true,
	managingBrokerSociety: {
		select: {
			id: true,
			denomination: true,
		},
	},
} satisfies Prisma.SocietySelect;
